import PropTypes from "prop-types"
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react"

import Checkbox from "@atoms/Checkbox/Checkbox"

const CheckboxGroup = forwardRef(
  ({ list, onCheck, initialState, className = "", groupName }, ref) => {
    const [checkedState, setCheckedState] = useState(initialState || {})

    useImperativeHandle(ref, () => ({
      resetState: () => setCheckedState({}),
    }))

    const onCheckHandler = ({ target: { checked, name } }) => {
      const newState = { ...checkedState }
      if (checked) newState[name] = checked
      else delete newState[name]

      setCheckedState(newState)
    }

    useEffect(
      () => onCheck({ checkedState, groupName }),
      [checkedState, groupName]
    )

    return (
      <div className={className}>
        {list?.map(({ name, label }, index) => (
          <Checkbox
            key={name}
            name={name}
            id={`${name}-checkbox`}
            label={label}
            onCheck={onCheckHandler}
            checked={checkedState[name] || false}
            className={index !== list.length - 1 ? "mb-2" : ""}
          />
        ))}
      </div>
    )
  }
)

CheckboxGroup.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
  onCheck: PropTypes.func,
  initialState: PropTypes.objectOf(PropTypes.bool.isRequired),
  groupName: PropTypes.string,
}

export default CheckboxGroup
